



























import Vue from 'vue'
import DropdownContents from './dropdown-contents'
import TopLevelNav from './top-level-nav'
import ClickOutside from 'vue-click-outside'
import HeaderHeightMixin from 'library/mixins/header-height'

export default

	mixins: [ HeaderHeightMixin ]

	components: {
		DropdownContents
		TopLevelNav
	}

	directives: {
		ClickOutside
	}

	data: ->
		selectedNav: null
		dropdownOpen: false
		active: 'none'

	mounted: ->
		document.addEventListener 'scroll', @onScroll

	destroyed: ->
		document.removeEventListener 'scroll', @onScroll

	computed:

		activeClasses: -> 'active'

		navigationData: -> @$store.state.globals.desktopNavigation
		navigationItems: -> @navigationData?.children || []

		open: -> !!@selectedNav

		# Helper to get the id property of selectedNav, if it's an object
		selectedNavId: -> @selectedNav?.id

		computedHeight: ->
			top: @headerHeight

	methods:

		onScroll: -> @hideDropdown() if @dropdownOpen

		# from click outside directive
		hideDropdown: ->
			@dropdownOpen = false
			@active = 'none'

		toggleDropdown: (item) ->

			return if item.href

			# if you click on the same one,
			# then close it all
			if @active == item.title
				@dropdownOpen = false
				@active = 'none'

			# else, swap which one is active
			else
				@dropdownOpen = true
				@active = item.title

	watch:

		# Close the nav when the route changes
		$route: ->
			@active = 'none'
			@selectedNav = null
			@dropdownOpen = false

